<template lang="pug">
el-drawer(
  title="新增預約"
  :visible.sync="drawer"
  direction="rtl"
  :before-close="handleClose"
  :append-to-body="appendToBody"
  destroy-on-close)
  .drawer.flex.column.gap-20.default
    .data.flex.column.align-stretch.gap-6
      .title 個案姓名
      template(v-if="cannotEditTarget")
        el-input.input(v-model="targetName" :disabled="cannotEditTarget")
      template(v-else)
        user-picker(@input="updateTarget")
        //- el-input.input(
        //-   v-model="name", placeholder="請輸入姓名")
    .data.flex.column.align-stretch.gap-6
      .title 專案
      .desc.text-secondary 若選擇後，預約價位將依照設定預先填入，該筆預約不向個案直接收取費用
      el-select(v-model="project" filterable clearable)
        el-option-group(
          v-for="group in organizations"
          v-if="group.public"
          :key="group.id"
          :label="group.name")
          el-option(
            v-for="p in group.projects"
            :key="p.id"
            :label="`${group.name} - ${p.name}`"
            :value="`${p.id}`")
            span {{ p.name }}
    .data.flex.column.align-stretch.gap-6
      .title 議題
      el-select(v-model="mainRequirementType", placeholder="請選擇")
        el-option(
          v-for="t in requirementTypes", :key="t.value"
          :label="t.label", :value="t.value")
    .data.flex.column.align-stretch.gap-6
      .title 專業人士
      pro-selector(
        v-model="professional"
        public-only
      )
      //- pro-picker(
      //-   ref="proPicker"
      //-   @clear="professional = undefined"
      //-   @input="professional = $event.id")
      //- el-select(v-model="professional")
      //-   el-option(v-for="p in professionalList",
      //-     :key="p.id", :value="p.id", :label="`${p.family_name}${p.given_name}`")
    .data.flex.column.align-stretch.gap-6
      .title 本次晤談為
      .flex.align-center.gap-10.wrap
        el-radio.radio(v-model="type" label="individual" border) 個別
        el-radio.radio(v-model="type" label="couple" border) 伴侶
        el-radio.radio(v-model="type" label="parent" border) 親子
        el-radio.radio(v-model="type" label="family" border) 家庭
        el-radio.radio(v-model="type" label="earlytreatment" border) 早療/早療團體
        el-radio.radio(v-model="type" label="supervise" border) 督導
    .data.flex.column.align-stretch.gap-6(v-if="type === 'couple'")
      .title 伴侶姓名
      user-picker(:exclude="targeID", @input="chooseRelation", ref="partnerPicker")
      .flex.align-center
        el-button(type="text", @click="quickAddRelation") 找不到會員？建立帳號
    .data.flex.column.align-stretch.gap-6(v-if="type === 'parent'")
      .title 對象
      .sub-type.flex.align-center.gap-6
        el-radio(v-model="subType", label="statutoryagents") 法代(會同時寄信給2人)
        el-radio(v-model="subType", label="children") 子女
      user-picker(:exclude="targeID", @input="chooseRelation", ref="partnerPicker")
      .flex.align-center
        el-button(type="text", @click="quickAddRelation") 找不到會員？建立帳號
    template(v-if="type === 'family' || type === 'earlytreatment' || type === 'supervise'")
      .data.flex.column.align-stretch.gap-6(
        v-for="(family, idx) in relationalTargets"
        :key="idx")
        .title 晤談成員{{ idx + 1 }}
        .flex.align-center.gap-10
          user-picker(:exclude="targeID", @input="chooseFamilyRelation(idx, $event)", ref="partnersPicker")
          el-button(icon="el-icon-remove-outline", @click="relationalTargets.splice(idx, 1)")
        .flex.align-center
          el-button(type="text", @click="quickAddFamilyRelation(idx)") 找不到會員？建立帳號
      el-button(icon="el-icon-plus", @click="addNewFamily") 新增晤談成員
    .data.flex.column.align-stretch.gap-6
      .title 型態
      .flex.align-center.gap-10
        el-radio.radio(v-model="locationType" label="inhouse" border) 實體
        el-radio.radio(v-model="locationType" label="virtual" border) 遠距
        el-radio.radio(v-model="locationType" label="phone" border) 電話
    .data.flex.column.align-stretch.gap-6(v-if="locationType === 'virtual'")
      .title 遠距諮商連結
      .flex.align-center.gap-10
        el-input.flex-1(v-model="remoteLink")
        el-button(type="primary" plain @click="generateRemoteLink") 生成連結
    .data.flex.column.align-stretch.gap-6
      .title 預約時長
      el-select(v-model="length")
        el-option(v-for="l in lengthOptions" :key="l", :value="l", :label="`${l}分鐘`")
    .data.flex.column.align-stretch.gap-6
      .title 預約日期
      .flex.align-center.gap-10
        el-date-picker.flex-1(
          @change="changeDate"
          v-model="startDate", type="date", placeholder="請選擇日期"
        )
        el-time-select.flex-1(
          ref='timeSelector'
          v-model="startTime"
          placeholder="請選擇時間"
          :picker-options="{start: '00:00',step: '00:30',end: '23:30'}")
      .desc(v-if="availabilityHint") {{ availabilityHint }}
    .data.flex.column.align-stretch.gap-6
      .title 場地空間
      el-select(
        v-model="branch", placeholder="請選擇館別")
        el-option(v-for="b in branchList", :key="b.id", :value="b.id", :label="b.name")
      .flex.align-center.gap-20
        el-select.flex-1(
          v-model="room",
          placeholder="請選擇空間", :disabled="branch === undefined")
          el-option(v-for="r in roomList", :key="r.id", :value="r.id", :label="r.name")
        el-button(
          :disabled="branch === undefined || startDate === undefined"
          type="text", @click="toggleRemainSpace") 查看當日空間
    .data.flex.column.align-stretch.gap-6
      .title 分帳模組
      el-select(v-model="accounting", placeholder="無")
        el-option(
          v-for="a in accountingList"
          v-if="a.public"
          :key="a.id", :value="a.id", :label="a.name")
    .data.flex.column.align-stretch.gap-6
      .title 預約價位
      el-input(v-model="price")
        template(slot="prepend") NT$
    .data.flex.column.align-stretch.gap-6
      .title 標記個案
      el-select(
        multiple, v-model="tags")
        el-option(
          v-for="tag in tagList",
          v-if="tag.public",
          :key="tag.name", :label="tag.name", :value="tag.name")
    .data.flex.column.align-stretch.gap-6
      .title 本次預約備註
      el-input(
        v-model="note"
        type="textarea", :autosize="{minRows: 3, maxRows: 3}")
    .op.flex.align-center-justify-stretch.gap-10
      el-button.flex-1(@click="cancel") 取消
      el-button.flex-1(@click="save", type="primary", :disabled="!valid") 新增
  appointment-room-view.space-view(
    :clickable="false"
    v-if="showSpace",
    :hour="showHour",
    :professional="professional", :availability="hintAvailability", :holidays="hintHolidays",
    :branch="branch", :time="startDate", public)
  quick-person-creator(
    ref="quickPersonCreator", :append-to-body="true", @finish="chooseRelation")
  quick-person-creator(
    ref="quickFamilyPersonCreator",
    :append-to-body="true", @finish="chooseFamilyRelation(targetFamilyIdx, $event)")
</template>

<script>
import { mapGetters } from 'vuex';
import { getTags } from '@/api/tags';
import { getBranches } from '@/api/place';
import { getProfessionalList } from '@/api/professionals';
import { getAccountingModels } from '@/api/accountModel';
import { getOrganizations, getOrganizationDetail } from '@/api/project';
import {
  addAppointment,
  getUserLastAppointment,
  // generateRemoteLink,
} from '@/api/reserve';
import {
  addCohost, isCohostWhitelisted, generateMeetLink, getMeetingCode, prepareMeetAuth,
} from '@/util/meet';
import UserPicker from '@/components/UserPicker.vue';
import availabilityHint from '@/util/availabilityHint';
import { parsePrice } from '@/util/validator';
import QuickPersonCreate from '@/components/drawers/QuickPersonCreate.vue';

export default {
  name: 'appointment-creator',
  mixins: [availabilityHint],
  components: {
    'user-picker': UserPicker,
    'quick-person-creator': QuickPersonCreate,
  },
  props: {
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: '',
      saving: false,
      drawer: false,
      target: undefined,
      project: undefined,
      mainRequirementType: undefined,
      requirementTypes: [
        { value: 'mental', label: '心理諮詢' },
        { value: 'law', label: '法律諮詢' },
        { value: 'finance', label: '財務諮詢' },
        { value: 'management', label: '組織管理' },
        { value: 'medical', label: '健康管理' },
      ],
      professional: undefined,
      startDate: undefined,
      startTime: '09:00',
      branch: undefined,
      room: undefined,
      accounting: undefined,
      price: undefined,
      tags: [],
      note: '',
      partner: undefined,
      subType: 'statutoryagents',

      relationalTarget: undefined,
      relationalName: '',
      relationalTargets: [],
      remoteLink: '',
      length: undefined,
      cannotEditTarget: false,

      type: 'individual',
      locationType: 'inhouse',

      projectList: [],
      professionalList: [],
      branchList: [],
      roomList: [],
      tagList: [],
      accountingList: [],
      accountingMap: {},
      organizations: [],

      branchMap: {},

      lengthOptions: [30, 60, 90, 120, 150, 180],
      showSpace: false,
      targetFamilyIdx: '',
      showHour: 9,
      projectOrgMap: {},
    };
  },
  computed: {
    ...mapGetters(['isUnlimitedAppointmentRole']),
    targetName() {
      if (this.target) {
        return `${this.target.family_name}${this.target.given_name}`;
      }
      return '';
    },
    targeID() {
      if (this.target) {
        return this.target.id;
      }
      return -1;
    },
    valid() {
      return true;
    },
    selectedAccounting() {
      return this.accountingMap[this.accounting];
    },
  },
  watch: {
    branch() {
      if (this.branch === undefined) {
        this.roomList = [];
        return;
      }
      this.roomList = this.branchMap[this.branch]?.rooms || [];
    },
    project() {
      this.loadProjectDetail();
    },
  },
  methods: {
    async loadProjectDetail() {
      const projectID = this.project;
      const orgID = this.projectOrgMap[projectID];
      if (orgID === undefined) {
        return '';
      }
      return this.$execWithLoadingMessage('載入專案資訊中', async () => {
        const detail = await getOrganizationDetail(orgID);
        const projectDetail = detail.projects.find((p) => p.id.toString() === projectID.toString());
        this.price = projectDetail.price;
        this.length = projectDetail.duration;
        this.mainRequirementType = projectDetail.main_requirement_type;
      }, (e) => this.$showAxiosException('載入專案資訊失敗', e));
    },
    handleClose(done) {
      this.$confirm('確定要取消新增預約?', '提醒', {
        confirmButtonText: '是',
        cancelButtonText: '否，繼續編輯',
        type: 'warning',
        customClass: 'button-revert',
      }).then(() => {
        done();
      }).catch(() => {
        done(false);
      });
    },
    close(result) {
      this.$emit('finish', result);
      this.drawer = false;
    },
    show() {
      this.drawer = true;
    },
    addNewFamily() {
      this.relationalTargets.push(undefined);
    },
    chooseFamilyRelation(idx, data) {
      if (data) {
        this.relationalTargets[idx] = data;
      }
    },
    generateAppointment() {
      const start = new Date(this.startDate);
      const [hour, minute] = this.startTime.split(':');
      start.setHours(hour, minute, 0, 0);
      const partners = [];
      if (this.type === 'couple' || this.type === 'parent') {
        partners.push(this.relationalTarget.id);
      } else if (this.type === 'family' || this.type === 'earlytreatment' || this.type === 'supervise') {
        partners.push(...this.relationalTargets.map((r) => r.id));
      }
      const data = {
        price: parsePrice(this.price),
        start_at: this.$dateToTimestamp(start),
        end_at: this.$dateToTimestamp(start) + this.length * 60,
        location_type: this.locationType,
        model_id: this.accounting,
        user_id: this.target.id,
        room_id: this.room,
        professional_id: this.professional,
        appointment_type: this.type,
        project_id: this.project === '' ? undefined : this.project,
        main_requirement_type: this.mainRequirementType,
        note: this.note,
        meeting_link: this.remoteLink,
        tags: this.tags,
        partners,
      };
      if (this.type === 'parent') {
        data.appointment_subtype = this.subType;
      }
      return data;
    },
    reset() {
      this.name = '';
      this.drawer = false;
      this.target = undefined;
      this.project = undefined;
      this.mainRequirementType = undefined;
      this.professional = undefined;
      this.startDate = undefined;
      this.startTime = '09:00';
      this.branch = undefined;
      this.room = undefined;
      this.accounting = undefined;
      this.price = undefined;
      this.tags = [];
      this.note = '';
      this.cannotEditTarget = false;
      this.showSpace = false;
      this.type = 'individual';
      this.remoteLink = '';
    },
    checkInput() {
      const errs = this.$initInputError();
      if (this.target === undefined) {
        errs.add('個案', '請選擇個案');
      }
      if (this.professional === undefined) {
        errs.add('專業人士', '請選擇專業人士');
      }
      if (this.accounting === undefined) {
        errs.add('分帳模組', '請選擇分帳模組');
      }
      if (this.startDate === undefined) {
        errs.add('預約日期', '請選擇預約日期');
      } else if (!this.isUnlimitedAppointmentRole) {
        // 管理者、派案人員、帳務人員不限制日期，其餘角色不能選今天以前
        const [hour, min] = this.startTime.split(':');
        const t = new Date(this.startDate);
        t.setHours(hour, min, 0, 0, 0);
        const todayStart = new Date();
        todayStart.setHours(0, 0, 0, 0, 0);
        if (t.getTime() < todayStart) {
          errs.add('預約時間', '預約時間不能早於今天');
        }
      }
      if (parsePrice(this.price) === undefined) {
        errs.add('預約價位', '請輸入預約價位');
      }
      if (this.branch === undefined || this.room === undefined) {
        errs.add('場地空間', '請選擇場地空間');
      }
      if (this.locationType === 'virtual' && this.remoteLink === '') {
        errs.add('遠距諮商連結', '請輸入連結');
      }
      if (this.selectedAccounting?.type === 'fixedprice' && parsePrice(this.price) < this.selectedAccounting?.organization_fixedprice) {
        errs.add('預約價位', `預約價位小於分帳定額金額 ${this.selectedAccounting.organization_fixedprice}`);
      }
      if (this.type === 'family' && this.relationalTargets.length <= 0) {
        errs.add('晤談成員', '諮商為家庭時，晤談成員至少需為一名');
      }

      if (errs.hasError) {
        const msg = errs.warnMessage;
        this.$showWarn(msg.title, msg.message);
        return false;
      }

      return true;
    },
    async save() {
      if (this.saving) {
        return false;
      }
      this.saving = true;
      try {
        return await this.doSave();
      } finally {
        this.saving = false;
      }
    },
    async doSave() {
      if (!this.checkInput()) {
        return false;
      }
      if (parsePrice(this.price) === 0) {
        try {
          await this.$showConfirm({
            title: '提醒',
            content: '是否確認要新價位為 0 的預約',
            confirmType: 'warning',
            confirmButtonText: '是',
            cancelButtonText: '否，繼續編輯',
            customClass: 'button-revert',
          });
        } catch (e) {
          return false;
        }
      }
      if (!await this.confirmAvailability(this.generateAppointment(), 'Create')) {
        return false;
      }
      return this.$execWithLoading(async () => {
        const appointment = this.generateAppointment();
        const cohostEmail = this.cohostEmail();
        const authError = cohostEmail ? await prepareMeetAuth().then(() => undefined, (e) => e) : undefined;
        await addAppointment(appointment);

        await this.setupCohost(cohostEmail, authError);
        this.$showSuccess('新增預約成功');
        this.close(true);
      }, (e) => {
        this.$showAxiosException('預約失敗', e);
      });
    },
    cancel() {
      this.close(false);
    },
    async loadData(notifyNoRecord = false) {
      await this.$execWithLoadingMessage('載入選項中', async () => {
        await Promise.all([
          this.loadProjects(),
          this.loadProfessionals(),
          this.loadBranchs(),
          this.loadTags(),
          this.loadAccountings(),
        ]);
      }, (e) => this.$showAxiosException('載入預約選項失敗', e));
      // 續約時查無前次預約，要告知使用者為何未帶入
      await this.loadLatestRecord(this.target, notifyNoRecord);
    },
    async loadProjects() {
      const rsp = await getOrganizations();
      this.projectOrgMap = {};
      rsp.forEach((org) => {
        org.projects.forEach((p) => {
          this.projectOrgMap[p.id] = org.id;
        });
        // eslint-disable-next-line no-param-reassign
        org.projects = org.projects.filter((p) => p.public);
      });
      this.organizations = rsp;
    },
    async loadProfessionals() {
      const list = await getProfessionalList();
      this.professionalList = list.filter((p) => p.public).map((p) => ({
        ...p,
        name: `${p.family_name}${p.given_name}`,
      }));
    },
    async loadBranchs() {
      const branches = await getBranches(true);
      this.branchList = branches.filter((b) => b.public);
      const m = {};
      branches.forEach((b) => {
        m[b.id] = b;
      });
      this.branchMap = m;
    },
    async loadTags() {
      const tags = await getTags();
      this.tagList = tags.filter((t) => t.public);
    },
    async loadAccountings() {
      const rsp = await getAccountingModels();
      this.accountingList = rsp.filter((a) => a.model_type === 'appointment');

      const accountingMap = {};
      rsp.forEach((a) => {
        accountingMap[a.id] = a;
      });
      this.accountingMap = accountingMap;
    },
    updateTarget(user) {
      this.target = user;
      this.loadLatestRecord(user);
    },
    // 需要設為 Google Meet 共同主持人的專業人士 email（僅白名單、只處理 Google Meet 連結），不需要時回傳空字串
    cohostEmail() {
      const email = this.professionalList.find((p) => p.id === this.professional)?.email;
      if (this.locationType !== 'virtual' || !getMeetingCode(this.remoteLink) || !isCohostWhitelisted(email)) {
        return '';
      }
      return email;
    },
    // 授權失敗不擋預約建立，只提示共同主持人沒設成
    async setupCohost(email, authError) {
      if (!email) {
        return;
      }
      if (authError) {
        this.$showWarn('設定共同主持人失敗', `預約已建立，但無法將 ${email} 設為 Google Meet 共同主持人。${authError.message}`);
        return;
      }
      try {
        await addCohost(this.remoteLink, email);
      } catch (e) {
        this.$showWarn('設定共同主持人失敗', `預約已建立，但無法將 ${email} 設為 Google Meet 共同主持人。${e.message}`);
      }
    },
    generateRemoteLink() {
      this.$execWithLoading(async () => {
        const { meetingUri, cohostError } = await generateMeetLink();
        this.remoteLink = meetingUri;
        if (cohostError) {
          this.$showWarn('設定共同主持人失敗', `連結已生成。${cohostError.message}`);
        }
      }, (e) => {
        this.$showError('生成連結失敗', e?.message || '未知錯誤');
      });
    },
    changeDate() {
      this.$refs.timeSelector.$el.querySelector('input').focus();
    },
    loadLatestRecord(user, notifyNoRecord = false) {
      if (!user) {
        return;
      }
      this.$execWithLoadingMessage('載入前次預約紀錄中', async () => {
        const detail = await getUserLastAppointment(user.id);

        this.length = (detail.end_at - detail.start_at) / 60;
        this.startTime = this.$timestampToTime(detail.start_at);
        this.accounting = detail.model?.id;
        if (detail.appointment_type === 'family' || detail.appointment_type === 'earlytreatment' || detail.appointment_type === 'supervise') {
          this.relationalTargets = detail.partners;
          this.$nextTick(() => {
            this.$refs.partnersPicker.forEach((p, idx) => {
              const partner = detail.partners[idx];
              p.$emit('name', `${partner.family_name}${partner.given_name}`);
            });
          });
        } else if (detail.partners.length > 0) {
          const [partner] = detail.partners;
          partner.value = `${partner.family_name}${partner.given_name}`;
          this.chooseRelation(partner);
          this.$nextTick(() => {
            this.$refs.partnerPicker.$emit('name', partner.value);
          });
        }

        this.professional = detail.professional.id;
        this.branch = detail.room.branch.id;
        this.room = detail.room.id;
        this.price = detail.price;
        this.tags = detail.tags;
        this.type = detail.appointment_type;
        this.locationType = detail.location_type;
        if (detail.project?.id) {
          this.project = detail.project.id.toString();
        }
      }, (e) => {
        if (e?.response?.status === 404) {
          // 後端：該個案沒有前次預約時回 404
          if (notifyNoRecord) {
            this.$showWarn('查無前次預約紀錄', '此個案沒有可帶入的前次預約，請手動填寫預約資料');
          }
          return;
        }
        this.$showAxiosException('載入前次預約紀錄失敗', e);
      });
    },
    chooseRelation(data) {
      this.relationalTarget = data;
    },
    quickAddRelation() {
      this.$refs.quickPersonCreator.$emit('show');
    },
    quickAddFamilyRelation(idx) {
      this.targetFamilyIdx = idx;
      this.$refs.quickFamilyPersonCreator.$emit('show');
    },
    toggleRemainSpace() {
      if (this.showSpace === false) {
        let [hour, minute] = this.startTime.split(':');
        hour = parseInt(hour, 10);
        minute = parseInt(minute, 10);
        if (minute !== 0) {
          hour += 0.5;
        }
        this.showHour = hour;
      }
      this.showSpace = !this.showSpace;
    },
  },
  mounted() {
    this.$on('show', (data) => {
      this.reset();
      this.target = data.user;
      if (this.target) {
        this.cannotEditTarget = true;
      }
      this.show();
      setTimeout(() => {
        this.loadData(data.renew === true);
      }, 100);
    });
  },
};
</script>

<style lang="scss" scoped>
.drawer {
  padding: 20px;
  padding-top: 0;
  .data {
    .desc {
      font-size: 12px;
    }
    .radio {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
}
.space-view {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 30vw !important;
  height: calc(100vh - 40px) !important;
  height: calc(100dvh - 40px) !important;
}
</style>
